export const API_URL = process.env.VUE_APP_API_URL + 'api/'
export const BASE_TOKEN = process.env.VUE_APP_API_URL ;
export const BASE_URL = process.env.VUE_APP_API_URL ;
export const VERSION = 'v1';
export const VERSIONED_API_URL = API_URL+VERSION;
export const CLIENT_SECRET = process.env.VUE_APP_API_SECRET;
export default {
    oauth: {
        grant_type: 'password',
        client_id: 2,
        client_secret: CLIENT_SECRET,
        scope: '*'
    },
    oauth_type: 'Bearer'
}
